import './CollectionItem.scss'

import { HDSButton, HDSTooltip } from '@here/hds-react-components'
import ConfirmationPrompt from 'components/App/components/ConfirmationPrompt'
import {
  CollectionCategory,
  getCollectionCategoryUrlPath,
} from 'components/Collections/util/collection-category'
import { i18n } from 'lib/i18n'
import React, { CSSProperties, useState } from 'react'

interface CollectionItemProps {
  id: string
  name: string
  count: number
  category?: CollectionCategory
  onClick?: (id: string) => void
  onEdit?: (id: string) => void
  onDelete?: (id: string, name: string) => void
}

export default function CollectionItem({
  id,
  name,
  count,
  category,
  onClick,
  onEdit,
  onDelete,
}: CollectionItemProps): JSX.Element {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [isItemHovered, setIsItemHovered] = useState(false)
  const placesLabel = i18n('collections.collection-list.places')
  const editCollectionLabel = i18n('collections.collection-list.actions.edit-collection')
  const deleteCollectionLabel = i18n('collections.collection-list.delete-confirmation.title')

  return (
    <>
      <div
        className="CollectionItem"
        onClick={() => onClick !== undefined && onClick(id)}
        onMouseEnter={() => setIsItemHovered(true)}
        onMouseLeave={() => setIsItemHovered(false)}
      >
        <div
          className="CollectionItem__category"
          style={
            {
              backgroundImage: `url("${getCollectionCategoryUrlPath(category)}")`,
            } as CSSProperties
          }
        />
        <div className="CollectionItem__ListView">
          <div className="CollectionItem__name">{name}</div>
          <div className="CollectionItem__places">
            <span>{placesLabel}: </span>
            <span>{count}</span>
          </div>
        </div>
        {isItemHovered && (
          <div className="CollectionItem__actions">
            <HDSTooltip position="bottom" interactive={false} content={editCollectionLabel}>
              <HDSButton
                icon="edit"
                variant="subtle"
                size="small"
                style={{ marginRight: '0.5rem' }}
                onClick={() => onEdit && onEdit(id)}
                data-tippy-offset="[0, 8]"
              />
            </HDSTooltip>
            <HDSTooltip position="bottom" interactive={false} content={deleteCollectionLabel}>
              <HDSButton
                icon="delete"
                variant="subtle"
                size="small"
                onClick={(e) => {
                  e.stopPropagation()
                  setShowDeleteConfirmation(true)
                }}
                data-tippy-offset="[0, 8]"
              />
            </HDSTooltip>
          </div>
        )}
      </div>

      {showDeleteConfirmation && (
        <ConfirmationPrompt
          modalTitle={i18n('collections.collection-list.delete-confirmation.title')}
          modalContent={i18n('collections.collection-list.delete-confirmation.subtitle')}
          confirmBtnText={i18n('collections.collection-list.actions.delete')}
          cancelBtnText={i18n('collections.collection-list.delete-confirmation.cancel')}
          confirmBtnVariant="danger"
          onConfirm={() => {
            setShowDeleteConfirmation(false)
            onDelete && onDelete(id, name)
          }}
          onCancel={() => setShowDeleteConfirmation(false)}
        />
      )}
    </>
  )
}
